import type { Lang } from '@bookingdei/i18n/translate';
import { formatClock } from '@bookingdei/i18n/format-date';
import type { ShowcaseProfile } from '../screens/home/showcase-profile';

// The demo business the home page's coded device mockups (app band, for-business
// showcase) print while no real business can fill them — none featured, or the one
// featured has no service menu and no team yet (an imported listing). It is the
// design's Persona Beauty Lounge, the same record the mock catalogue carries, so the
// mockups read exactly as the design does until a full merchant is featured.
// Decorative only: the mockups are aria-hidden and link nowhere.

const photo = (id: string, w: number, h: number) => `https://images.unsplash.com/${id}?w=${w}&h=${h}&q=60&auto=format&fit=crop`;

const COPY = {
  en: {
    name: 'Persona Beauty Lounge',
    area: 'Gulshan, Dhaka',
    services: [
      { name: 'Haircut & blow dry', minutes: 45, taka: 600 },
      { name: 'Keratin treatment', minutes: 150, taka: 4500 },
    ],
    calendar: ['Bridal makeup (full)', 'Keratin treatment', 'Signature facial', 'Haircut & blow dry', 'Gold glow facial', 'Root touch-up color', 'Threading & brow', 'Hair spa', 'Blow dry'],
    customers: ['Nusrat Jahan', 'Sadia Rahman', 'Tanjina R.', 'Mahia S.', 'Nishat A.', 'Priya T.', 'Ruma D.', 'Farhana K.', 'Nadia I.'],
    staff: ['Rumana', 'Taslima', 'Bithi', 'Shorna'],
  },
  bn: {
    name: 'পারসোনা বিউটি লাউঞ্জ',
    area: 'গুলশান, ঢাকা',
    services: [
      { name: 'হেয়ারকাট ও ব্লো ড্রাই', minutes: 45, taka: 600 },
      { name: 'কেরাটিন ট্রিটমেন্ট', minutes: 150, taka: 4500 },
    ],
    calendar: ['ব্রাইডাল মেকআপ (পূর্ণ)', 'কেরাটিন ট্রিটমেন্ট', 'সিগনেচার ফেসিয়াল', 'হেয়ারকাট ও ব্লো ড্রাই', 'গোল্ড গ্লো ফেসিয়াল', 'রুট টাচ-আপ কালার', 'থ্রেডিং ও ভ্রু', 'হেয়ার স্পা', 'ব্লো ড্রাই'],
    customers: ['নুসরাত জাহান', 'সাদিয়া রহমান', 'তানজিনা র.', 'মাহিয়া স.', 'নিশাত আ.', 'প্রিয়া ত.', 'রুমা দ.', 'ফারহানা ক.', 'নাদিয়া ই.'],
    staff: ['রুমানা', 'তাসলিমা', 'বিথী', 'স্বর্ণা'],
  },
} as const;

const STAFF_PHOTOS = ['photo-1544725176-7c40e5a71c5e', 'photo-1595956553066-fe24a8c33395', 'photo-1531746020798-e6953c6e8e04', 'photo-1592621385612-4d7129426394'];
const MEDIA_COUNT = 6;
const SERVICE_COUNT = 9;

export interface DemoShowcase {
  profile: ShowcaseProfile;
  customers: string[];
  services: string[];
  mediaCount: number;
}

export function demoShowcase(lang: Lang): DemoShowcase {
  const c = lang === 'bn' ? COPY.bn : COPY.en;
  return {
    profile: {
      name: c.name,
      cover: photo('photo-1560066984-138dadb4c035', 800, 600),
      rating: 4.8,
      reviews: 486,
      area: c.area,
      hours: `${formatClock(lang, 9, 0)}–${formatClock(lang, 21, 0)}`,
      payKey: 'payment.bkash',
      services: c.services.map((s) => ({ name: s.name, minutes: s.minutes, price: s.taka * 100 })),
      serviceCount: SERVICE_COUNT,
      staff: c.staff.map((name, i) => ({ name, photo: photo(STAFF_PHOTOS[i]!, 200, 200) })),
    },
    customers: [...c.customers],
    services: [...c.calendar],
    mediaCount: MEDIA_COUNT,
  };
}
